module.exports = __webpack_public_path__ + "199ff060f30daa374daaf91f88a88f6f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-7.png
// module id = 3477
// module chunks = 0